import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//Main Components
import { ListBuilderComponent } from '../../components/main/list-builder/list-builder.component';
import { OptionsComponent } from '../../components/main/options/options.component';
import { AttachmentsGroupComponent } from '../../attachments-group.component';

const appRoutes: Routes = [
  {
    path: 'attachments-group',
    component: AttachmentsGroupComponent,
    data: { title: 'Attachments Group' }
  },
  {
    path: 'attachments-list-builder',
    component: ListBuilderComponent,
    data: { title: 'Attachments List Builder' }
  },
  {
    path: 'attachments-group-options',
    component: OptionsComponent,
    data: { title: 'Attachments Group Options' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class RoutingModule {}
